export default __webpack_public_path__ + "static/paleto_bay_meth_lab-8d097b729267308b47481feafdef90e7.png";